angular.module('dnecom')
    .controller('licenseUpgradeModalController', ["$scope", "$uibModalInstance", "licenseError", "store", function ($scope, $uibModalInstance, licenseError, store) {
        $scope.licenseError = licenseError;

        $scope.cancel = function () {
            if (store) {
                document.location.href = Routing.generate('stores_dashboard', { id: store.id });
            } else {
                document.location.href = '/';
            }
        };
    }]); 